import React from "react";
import { useSearchParams } from "react-router-dom";

import { ModalsProvider } from "../../components/PurchaseFlow/NewCheckoutWrapper/providers/ModalsProvider";
import { TicketsProvider } from "../../components/PurchaseFlow/NewSeatedPurchaseWrapper/providers/TicketsProvider/TicketsProvider";

import { CheckoutSuccessWrapper } from "../../components/PurchaseFlow/CheckoutSuccessWrapper";

export default function CheckoutSuccessPage() {
  const [searchParams] = useSearchParams();
  let intentId = searchParams.get("intentId");

  return (
    <ModalsProvider>
      <CheckoutSuccessWrapper intentId={intentId} />
    </ModalsProvider>
  );
}
